var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import HealthHistoryCardAPI from './health-history-card-api';
import React, { Component } from 'react';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { Avatar, Card } from '@philips-internal/oswald-ui-components/lib/components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { generateUUID, isFunction } from '@philips-internal/oswald-ui-utils';
import clinicalNotesImage from '../../assets/images/global/clinical-notes-40x40.svg';
import { ReactComponent as PendingIcon } from '../../assets/images/global/time.svg';
import { ReactComponent as ReleasedIcon } from '../../assets/images/global/check.svg';
import './health-history-card.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { DateFormatterUtil } from '../../utils';
const legends = [
    {
        color: 'signal-green-60',
        icon: React.createElement(ReleasedIcon, null),
        label: MessageService.translate('text.finished'),
        value: MessageService.translate('text.finished')
    },
    {
        color: 'signal-orange-45',
        icon: React.createElement(PendingIcon, null),
        label: MessageService.translate('tws.label-pending'),
        value: MessageService.translate('tws.label-pending')
    }
];
let HealthHistoryCard = class HealthHistoryCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { idHealthHistory, onClick, professionalName, recordDate, releaseDate, } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        idHealthHistory,
                        professionalName,
                        recordDate,
                        releaseDate,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    getStatusIcon() {
        const { releaseDate } = this.props;
        if (releaseDate) {
            return React.createElement(ReleasedIcon, { className: 'c-health-history-card__color-green' });
        }
        return React.createElement(PendingIcon, { className: 'c-health-history-card__color-orange' });
    }
    renderStatus() {
        return (React.createElement("div", { className: 'c-health-history-card__status' }, this.getStatusIcon()));
    }
    renderIndicatorColorStatus() {
        const { releaseDate } = this.props;
        if (releaseDate) {
            return React.createElement("div", { className: 'c-health-history-card__indicator-color-green' });
        }
        return React.createElement("div", { className: 'c-health-history-card__indicator-color-orange' });
    }
    renderIndicator() {
        return (React.createElement("div", { className: 'c-health-history-card__indicator' }, this.renderIndicatorColorStatus()));
    }
    renderAvatar() {
        const { professionalName, recordDate } = this.props;
        const localDate = DateFormatterUtil.short(String(recordDate));
        return (React.createElement("div", { className: 'c-health-history-card__cn-avatar' },
            this.renderStatus(),
            React.createElement(Avatar, { image: clinicalNotesImage, title: localDate, subtitle: professionalName })));
    }
    render() {
        const { idHealthHistory } = this.props;
        return (React.createElement(Card, { className: 'c-health-history-main', selectionType: SelectionType.SINGLE, superscription: legends, width: 12, onClick: this.handleClick, uuid: generateUUID(), key: idHealthHistory },
            this.renderIndicator(),
            React.createElement("div", { className: 'c-health-history-card__cn-wrapper', onClick: () => this.handleClick() }, this.renderAvatar())));
    }
};
HealthHistoryCard = __decorate([
    AwesomeComponent({ api: HealthHistoryCardAPI, type: ComponentType.DATA_DISPLAY })
], HealthHistoryCard);
export default HealthHistoryCard;
//# sourceMappingURL=health-history-card.js.map